
export default {
  name: 'VsCarouselPager',
  inject: ['carousel'],
  props: {
    vertical: {
      type: [Boolean, Object],
      default: false
    },
    color: {
      type: [String, Object],
      default: 'grey'
    },
    activeColor: {
      type: [String, Object],
      default: 'primary'
    },
    icon: {
      type: String,
      default: 'circle'
    },
    activeIcon: {
      type: String,
      default: null
    }
  },
  vessel: {
    item: {
      cursor: 'pointer'
    },
    icon: {
      $color: 'color'
    },
    iconActive: {
      $activeColor: 'color'
    }
  },
  computed: {
    pages() {
      return this.carousel.pages || [0]
    }
  },
  methods: {
    isActive(index) {
      return this.carousel.isPageActive(index)
    },
    itemAttrs(index) {
      const active = this.isActive(index)
      const vessel = active
        ? 'iconActive'
        : 'icon'

      const name = active && this.activeIcon
        ? this.activeIcon
        : this.icon

      return { name, class: this.$vessels[vessel] }
    },
    onClick(index) {
      this.carousel.scrollTo(index)
    }
  }
}
